import React from 'react';
import { useIntl } from 'react-intl';

export const CollapsibleSection = ({ title, isOpen, onToggle, children, status }) => {
  const intl = useIntl();

  return (
    <li className={isOpen ? 'active' : ''}>
      <button
        type="button"
        className="dp-accordion-thumb dp-accordion-thumb--with-top-border"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span className="dp-accordion-header dp-accordion-header--nowrap">
          <span className="dp-accordion-title">{title}</span>
          {typeof status === 'boolean' ? (
            <span className={`pill ${status ? 'pill--green' : 'pill--grey'}`}>
              <span className="pill-text">
                {intl.formatMessage({
                  id: status ? 'common.active' : 'common.disabled',
                })}
              </span>
            </span>
          ) : null}
          <span className="dp-accordion-icon" aria-hidden="true" />
        </span>
      </button>
      <div hidden={!isOpen}>
        <div className="dp-accordion-content">{children}</div>
      </div>
    </li>
  );
};
